import Box from 'components/Box';
import Text from 'components/Text';
import colorTheme from 'constants/color';
import { DATE_FORMAT } from 'features/appointment/utils/format';
import CashDepositTable from 'features/report/pages/ReportPage/CashDepositReport/Table';
import StaffSelector from 'features/report/pages/ReportPage/ClockReport/components/StaffSelector';
import AppointmentDatePicker from 'features/report/pages/ReportPage/components/DatePicker';
import SwitchCalendarType from 'features/report/pages/ReportPage/components/SwitchCalendarType';
import { ReportType } from 'features/report/pages/ReportPage/constants';
import reportActions from 'features/report/services/actions';
import reportSelectors from 'features/report/services/selectors';
import { find } from 'lodash';
import moment from 'moment';
import { useEffect, useMemo } from 'react';
import shopSelectors from 'services/shop/selectors';
import { IStaffItemData } from 'services/shop/types/staff';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';

const CashDepositReport = () => {
  const dispatch = useAppDispatch();
  const staffData = shopSelectors.data.staffs()?.filter(f => !f.anyBody);
  const dataAppointment = reportSelectors.getParams()?.[ReportType.CASH_DEPOSIT];

  const staffSelected = useMemo(() => {
    if (!dataAppointment?.staffId) return undefined;
    return find(staffData, (o: IStaffItemData) => o.id === dataAppointment.staffId);
  }, [dataAppointment, staffData]);

  const onChangeStaffSelected = (value: IStaffItemData | null) => {
    const params = {
      ...dataAppointment || {
        startTime: moment().format(DATE_FORMAT),
        endTime: moment().format(DATE_FORMAT),
      },
      staffId: value?.id || undefined,
    };
    if (!params.staffId) {
      delete params.staffId;
    }

    dispatch(reportActions.setParams({
      [ReportType.CASH_DEPOSIT]: params
    }));
  };

  useEffect(() => {
    dispatch(reportActions.setParams({
      [ReportType.CASH_DEPOSIT]: {
        startTime: dataAppointment?.startTime || moment().format(DATE_FORMAT),
        endTime: dataAppointment?.endTime || moment().format(DATE_FORMAT)
      }
    }));
  }, []);

  return (
    <StyledEmployeeSalary className='v2'>
      <HeaderBox className={'v2'}>
        <Box pt='3' pb='4' style={{ flex: 1 }}>
          <Text className='title-page' variant="H5">CASH DEPOSIT</Text>
        </Box>
        <StaffSelector v2 size='middle' data={staffData} onChange={onChangeStaffSelected} selected={staffSelected} />
        <SwitchCalendarType v2 twoWeeks actions={reportActions} selectors={reportSelectors} type={ReportType.CASH_DEPOSIT} />
        <AppointmentDatePicker v2 size='middle' actions={reportActions} selectors={reportSelectors} type={ReportType.CASH_DEPOSIT} />
      </HeaderBox>
      <CashDepositTable />
    </StyledEmployeeSalary>
  );
};

export default CashDepositReport;
const StyledEmployeeSalary = styled.div`
    min-height: 100vh;
    background-color: ${colorTheme.fill_3};
    padding: 1.5rem;
    direction: flex;
    flex-direction: column;
    gap: 1.5rem;
    &.v2 {
        gap: 16px;
        background: #F5F5F5;
        padding: 16px;
        min-height: unset;
    }
`;

const HeaderBox = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;
`;

